<template>
  <v-app-bar
    class="accent item"
    id="header"
    elevate-on-scroll
    :hide-on-scroll="!smAndDown"
    :height="smAndDown ? '116px' : '138px'"
    app
  >
    <v-container class="px-3 pt-3 pt-md-0 pb-0 position-relative">
      <div class="d-flex flex-column position-relative">
        <v-row no-gutters>
          <v-col
            cols="12"
            md="4"
            lg="6"
            class="d-flex align-center"
            :class="smAndDown ? 'justify-space-between' : ''"
          >
            <v-btn
              class="text-none px-0"
              color="transparent"
              :exact="false"
              to="/"
              :height="smAndDown ? '42px' : '61px'"
              depressed
              plain
            >
              <img
                v-if="informations.img"
                class="d-block rounded-pill item-img"
                :src="files + informations.img"
                :alt="informations.name"
                :height="smAndDown ? '42px' : '61px'"
                :width="smAndDown ? '42px' : '61px'"
              />

              <span
                class="black--text text-body-1 text-md-h6 font-weight-bold ml-2"
              >
                {{ informations.short_name }}
              </span>
            </v-btn>
          </v-col>

          <v-col
            cols="12"
            md="8"
            lg="6"
            class="py-3 item-search d-flex align-center"
          >
            <v-form @submit="searchSubmit">
              <v-text-field
                v-model="q"
                @click:prepend-inner="searchSubmit"
                placeholder="Buscar"
                :background-color="smAndDown ? '#F1F1F1' : '#F1F1F1'"
                :height="smAndDown ? '30px' : '56px'"
                prepend-inner-icon="fa-search"
                :outlined="!smAndDown"
                :dense="smAndDown"
                :solo="smAndDown"
                type="text"
                hide-details
                flat
              ></v-text-field>
            </v-form>

            <template v-if="menu.length">
              <v-menu offset-y left tile>
                <v-sheet color="primary" height="3px" width="100%"></v-sheet>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    color="transparent"
                    depressed
                    :small="smAndDown"
                    :height="smAndDown ? '38px' : ''"
                    fab
                  >
                    <v-icon
                      color="secondary"
                      :size="smAndDown ? '28px' : '35px'"
                    >
                      fa-bars
                    </v-icon>
                  </v-btn>
                </template>
                <v-list tile>
                  <v-list-item
                    v-for="({ text, bind }, keyMenu) in menu"
                    :key="keyMenu"
                    v-bind="bind"
                  >
                    <v-list-item-title class="grey--text text--darken-3">
                      {{ text }}
                    </v-list-item-title>
                  </v-list-item>

                  <PwaButtonWidget class="px-3" block />

                  <template v-if="social.length">
                    <v-list-item class="d-flex justify-center">
                      <template v-for="{ link, icon } in social">
                        <v-btn
                          :key="link"
                          :href="link"
                          target="_blank"
                          color="transparent"
                          depressed
                          small
                          fab
                        >
                          <v-icon color="secondary">
                            {{ icon }}
                          </v-icon>
                        </v-btn>
                      </template>
                    </v-list-item>
                  </template>
                </v-list>
              </v-menu>
            </template>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import PwaButtonWidget from "../widgets/PwaButtonWidget.vue";
import { getMenu } from "../../utils/getMenu";
import { getSocial } from "../../utils/getSocial";
import { formatToURL } from "../../utils/formatToURL";

export default {
  data: () => ({
    q: "",
  }),
  created() {
    this.$rest("about").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("howBuy").get({
      save: (state, data) => (state.item = data),
    });
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    config() {
      return this.$rest("config").item;
    },
    about() {
      return this.$rest("about").item;
    },
    howBuy() {
      return this.$rest("howBuy").item;
    },
    social() {
      return getSocial(this.informations);
    },
    menu() {
      const component = {
        config: this.config,
        about: !!this.about.text,
        howBuy: !!this.howBuy.text,
      };

      return getMenu(component);
    },
    totalItemsCart() {
      return this.$shoppingCart.container.items.reduce(
        (r, { state: { quant } }) => r + quant,
        0
      );
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    searchSubmit(event) {
      event.preventDefault();

      const query = {};
      query.q = this.q;

      this.$router.push({ path: "/", query: query });
    },
    formatToURL,
    scrollTo(id) {
      const headerHeight =
        document.getElementById("header").getBoundingClientRect().height + 20;
      const goTo =
        document.getElementById(id).getBoundingClientRect().top - headerHeight;

      window.scrollBy({ top: goTo, behavior: "smooth" });
    },
  },
  watch: {
    $route() {
      if (this.q && !this.$route.query.q) this.q = "";
    },
  },
  components: {
    PwaButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-bottom: 1px solid #f1f1f1 !important ;

  @media (max-width: 960px) {
    border-bottom: none !important;
  }

  &-img {
    border: 1px solid #cccccc;
    -o-object-fit: contain;
    object-fit: contain;
    padding: 2px;
  }

  &-search {
    form {
      width: 100%;
    }
  }
}

.item::v-deep {
  .v-toolbar__content {
    padding: 0 !important;
  }

  .item-search {
    form {
      .v-input__prepend-inner {
        padding-left: 4px;
        padding-right: 12px;
      }

      .v-input__icon {
        button {
          color: var(--v-primary-base) !important;
        }
      }

      fieldset {
        color: #f1f1f1 !important;
      }
    }
  }

  .v-badge__badge {
    border: 1px solid var(--v-secondary-base) !important;
    color: var(--v-secondary-base);
  }
}
</style>
